import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ISalRepFilter } from "./salesReport/Filter";
import { Fetch } from "../../shared/Fetch";
import { Publish } from "../requirement/Publish";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { Interview_Process } from "../../models/RequirementMast";


interface Iprops {
    open: boolean,
    hideDialog: () => void,
    toast?: any,
    salEffFilter: any,
    salesID?: number,
    resType: number,
    catID?: number,
    branchID?: number
}

const popupHeader = (resType: number): string => {
    if (resType === 1) return "Client Wise Sales Performance Report";
    else if (resType === 2) return "Requirement Wise Sales Performance Report";
    else if (resType === 3) return "Sales Onsite Requirement Report";
    else if (resType === 4) return "Sales Hybrid Requirement Report";
    else if (resType === 5) return "Sales Remote Requirement Report";
    else if (resType === 6) return "Sales F2F Requirement Report";
    else if (resType === 7) return "Sales Phone/Skype Requirement Report";
    else if (resType === 8) return "Sales UnServed Requirement Report";
    else if (resType === 9) return "Sales Served Requirement Report";
    else if (resType === 11) return "Requirement Wise Sales Submission Report";
    else if (resType === 12) return "Sales Accepted Submission Report";
    else if (resType === 13) return "Sales Rejected Submission Report";
    else return "Report";
}

export const SkiilsSalesSubTableReport = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<{}>, loading: boolean });
    const dt = useRef<any>(null);

    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    const [publish, setPublish] = useState({ singleData: {}, open: false } as { singleData: { req_ID?: number }, open: boolean });
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        let response;
        let filterQuery = "";
        if (props.catID)
            filterQuery += `&catID=${props?.catID}`;
        if (props.salesID)
            filterQuery += `&salesID=${props.salesID}`;
        if (props.branchID)
            filterQuery += `&branchID=${props.branchID}`;
        if (props.resType === 1) response = await Fetch("Report_Sales/saldetail", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&resType=${props.resType}` + filterQuery, props.toast);
        else response = await Fetch("Report_Sales/reqsaldetail", "GET", null, `filter=${JSON.stringify(props.salEffFilter)}&resType=${props.resType}` + filterQuery, props.toast);
        if (response) {
            const data: Array<{ sn: number }> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const addOn = (rowData: { addOn: Date }) => {
        let date;
        if (rowData.addOn) date = format(new Date(rowData.addOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const onHide = () => {
        props.hideDialog();
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">{popupHeader(props.resType)}</h5>
            <Button label="Export" icon="pi pi-upload" className="p-button-help w-8rem mr-3" onClick={exportCSV} />
        </div>
    );
    const req_Job_Title = (rowData: { req_ID: number, req_Job_Title: string }) => {
        return (<span onClick={() => setPublish({ singleData: { req_ID: rowData.req_ID }, open: true })}
            className="cursor-pointer text-cyan-700 underline">
            {rowData.req_Job_Title}
        </span>);
    };

    const rowClass = (data: any) => {

        return {
            'bg-green-300 text-white': data.client_BG_Color === 1,
            'bg-purple-300 text-white': data.client_BG_Color === 2

        };
    }

    const DateFormat = loginObj.date_Format;
    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={header} modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows showGridlines scrollable scrollHeight="70vh"
                value={tableData.tableData}
                loading={tableData.loading}
                rowClassName={rowClass}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />

                {props.resType === 1 && !(_role.includes(40)) && <Column field="vendor_Company_Name" header="Vendor Company" />}
                {props.resType === 1 && <Column field="req_ID" header="Req ID" />}
                {props.resType === 1 && <Column field="contact_Person_Name" header="Contact Person" />}
                {/* {props.resType === 1 && <Column field="addOn" header="AddOn" body={addOn} />} */}
                {props.resType === 1 && <Column field="addOn" header="AddOn" body={(rowData: any) => safeFormatDate(rowData.addOn, 'dd/MM/yyyy', DateFormat)} />}
                {props.resType === 1 && <Column field="req" header="#Req" sortable />}
                {props.resType === 1 && <Column field="f2f" header="#F2F" sortable />}
                {props.resType === 1 && <Column field="noF2F" header="#NoF2F" sortable />}
                {props.resType === 1 && <Column field="served" header="#Served" sortable />}
                {props.resType === 1 && <Column field="unServed" header="#UnServed" sortable />}
                {props.resType === 1 && <Column field="sub" header="#Sub" sortable />}
                {props.resType === 1 && <Column field="eci" header="#ECI" sortable />}
                {props.resType === 1 && <Column field="po" header="#PO" sortable />}

                {props.resType !== 1 && <Column field="req_ID" header="Req ID" sortable />}
                {props.resType !== 1 && <Column field="req_Job_Title" header="Job Title" body={req_Job_Title} />}
                {props.resType !== 1 && <Column field="req_Duration" header="Duration" />}
                {props.resType !== 1 && <Column field="location" header="Location" />}
                {props.resType !== 1 && <Column field="req_Rate" header="Rate" />}
                {props.resType !== 1 && <Column field="req_InterviewProcess" header="InterviewProcess" body={(rowData: any) => rowData.req_InterviewProcess ? Interview_Process[rowData.req_InterviewProcess] : ""} />}
                {props.resType !== 1 && <Column field="resume" header="#Resume" sortable />}
                {props.resType !== 1 && <Column field="eci" header="#ECI" sortable />}
                {props.resType !== 1 && <Column field="po" header="#PO" sortable />}
                {props.resType !== 1 && <Column field="status" header="Status" />}
                {props.resType !== 1 && <Column field="accSub" header="#AccSub" />}
                {props.resType !== 1 && <Column field="rejSub" header="#RejSub" />}
            </DataTable>
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
        </Dialog>
    );
}